import { render, staticRenderFns } from "./UploadMedia.vue?vue&type=template&id=5b64af9d&scoped=true&"
import script from "./UploadMedia.vue?vue&type=script&lang=js&"
export * from "./UploadMedia.vue?vue&type=script&lang=js&"
import style0 from "./UploadMedia.vue?vue&type=style&index=0&id=5b64af9d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64af9d",
  null
  
)

export default component.exports